import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { GuestlistTagCount } from "@common/utils/guestlistTagCounts";

type GuestlistTagCountsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  tagCounts: GuestlistTagCount[];
};

export function GuestlistTagCountsModal({
  isOpen,
  onClose,
  tagCounts,
}: GuestlistTagCountsModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      size="lg"
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Tags</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {tagCounts.length === 0 ? (
            <Text color="gray.600" fontSize="sm">
              No tags on this guestlist
            </Text>
          ) : (
            <Box overflowY="auto">
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Tag</Th>
                    <Th isNumeric>Count</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {tagCounts.map((row) => (
                    <Tr key={row.tag}>
                      <Td>{row.tag}</Td>
                      <Td isNumeric>{row.count}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
